import type { APIListingEvent } from "models/types/api-listing";
import { CardRecordInsetDescription } from "components/cards/card-record-inset-description";
import { OpenHomeEventInsetFooter } from "modules/vendor-portal/screens/overview/components/open-home-events/footer/open-home-event-inset-footer";
import { PrivateInspectionEventInsetFooter } from "modules/vendor-portal/screens/overview/components/open-home-events/footer/private-inspection-event-inset-footer";

export function EventFeedbackInset({ event }: { event: APIListingEvent }) {
  const color = "gray.100"; // Use a default color as interest_level is not available

  return (
    <CardRecordInsetDescription
      color={color}
      description={event.feedback?.note}
      neverTruncate={true}
      showMoreElement={({ isTruncated }) => {
        if (event.type.id === "open_home") {
          return (
            <OpenHomeEventInsetFooter event={event} isTruncated={isTruncated} />
          );
        } else {
          return (
            <PrivateInspectionEventInsetFooter
              event={event}
              isTruncated={isTruncated}
            />
          );
        }
      }}
    />
  );
}
